class UpsellModal extends HTMLElement {
  connectedCallback() {
    this._isOpen = false;
    this._dialog = this.querySelector('dialog');
    this._headingEl = this._dialog.querySelector('.upsell-modal__heading');
    this._grid = this._dialog.querySelector('.upsell-modal__grid');

    const settings = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
    this._headingTemplate = settings.headingTemplate;
    this._addedLabel = settings.addedLabel;

    this._dialog.querySelector('.upsell-modal__close').addEventListener('click', () => this._close());
    this._dialog.addEventListener('click', (e) => {
      if (e.target === this._dialog) this._close();
    });

    this.addEventListener('variant:add', (e) => {
      e.detail.blockCartDrawerOpening = true;
    }, true);

    document.addEventListener('variant:add', this._onVariantAdd.bind(this), true);
  }

  _onVariantAdd(event) {
    if (event.detail.source !== 'bundle-builder') return;
    event.detail.blockCartDrawerOpening = true;
    if (this._isOpen) return;

    const items = event.detail.items;
    const productTitle = items?.[0]?.title || '';
    const productId = items?.[0]?.product_id;
    if (!productId) return;

    this._headingEl.textContent = this._headingTemplate.replace('{{ title }}', productTitle);
    this._fetchRecommendations(productId);
  }

  async _fetchRecommendations(productId) {
    this._grid.innerHTML = '';

    try {
      const res = await fetch(
        `/recommendations/products?product_id=${productId}&limit=4&intent=related&section_id=upsell-modal`
      );
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const cards = doc.querySelectorAll('.upsell-modal__card');

      if (cards.length === 0) {
        this._openCart();
        return;
      }

      for (const card of cards) {
        this._grid.appendChild(document.adoptNode(card));
      }

      this._attachInnerAtcListeners();
      this._show();
    } catch {
      this._openCart();
    }
  }

  _attachInnerAtcListeners() {
    for (const form of this._grid.querySelectorAll('form[is="product-form"]')) {
      form.addEventListener('variant:add', () => {
        const btn = form.querySelector('.upsell-modal__atc-btn');
        if (!btn) return;
        btn.style.minWidth = btn.offsetWidth + 'px';
        const textEl = btn.querySelector('.button-text');
        if (textEl) textEl.textContent = this._addedLabel;
        btn.disabled = true;
        btn.classList.add('upsell-modal__atc-btn--added');
      });
    }
  }

  _show() {
    this._isOpen = true;
    this._dialog.showModal();
  }

  _close() {
    this._isOpen = false;
    this._dialog.close();
  }

  _openCart() {
    window.location.href = '/cart';
  }
}

customElements.define('upsell-modal', UpsellModal);
